import { createAction, props } from '@ngrx/store';
import { Screen } from '../../models/screen.model';

export const updateScreen = createAction(
    '[Screen] Update Screen',
    props<{ selectedScreen: Screen }>()
);
